<div class="ad">
	<div class="adDiv" style="max-width: 940px; width: 100%">
		<h1>
			Get instants insights from the people who
			<br />
			matter most
		</h1>
		<div class="image-container" style="width: 100%">
			<div class="image-block">
				<img src="/assets/images/phone-screen.png" loading="lazy" alt="" />
				<h3>Convenient Access</h3>
			</div>
			<div class="image-block">
				<img src="/assets/images/speech-bubbles.svg" loading="lazy" alt="" />
				<h3>Real-time Feedback</h3>
			</div>
			<div class="image-block">
				<img src="/assets/images/light-bulb.svg" loading="lazy" alt="" />
				<h3>Impactful Insights</h3>
			</div>
		</div>
	</div>
</div>

<div #targetDiv class="qr">
	<h1>Schedule a demo today</h1>
	<img src="/assets/images/qr-code-yellow.png" loading="lazy" width="250" alt="" />
	<a href="https://jotto.me/connect" class="link-block w-inline-block"><h5>https://jotto.me/connect</h5></a>
</div>